import {Col, Row} from 'react-bootstrap-v5'
import {Modal} from 'rsuite'

type Props = {
  data: {
    full_name: string
    email: string
    mobile_number: string
    message: string
    subject?: string | null
    contact_type?: string | null
  }
  handleClose: () => void
}
const ViewDetailsModal = ({handleClose, data}: Props) => {
  return (
    <div className='modal-container'>
      <Modal
        open={true}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>Feedback Details </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Row>
              <Col md={6}>
                <b>Full Name</b>
              </Col>
              <Col md={6}>
                <p>{data.full_name}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Email</b>
              </Col>
              <Col md={6}>
                <p>{data.email}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Mobile Number</b>
              </Col>
              <Col md={6}>
                <p>{data.mobile_number}</p>
              </Col>
            </Row>
            {data.subject && (
              <Row>
                <Col md={6}>
                  <b>Subject</b>
                </Col>
                <Col md={6}>
                  <p>{data.subject}</p>
                </Col>
              </Row>
            )}
            {data.contact_type && (
              <Row>
                <Col md={6}>
                  <b>Contact Type</b>
                </Col>
                <Col md={6}>
                  <p>{data.contact_type}</p>
                </Col>
              </Row>
            )}
            <Row>
              <Col md={6}>
                <b>Message</b>
              </Col>
              <Col md={6}>
                <p>{data.message}</p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default ViewDetailsModal
